import { ColumnType } from "../../../../../shared/infrastructure/ui/components/libs/table/types";
import { StopNotes } from "@private/offers/domain";
import { Table } from "../../../../../shared/infrastructure";
import React, { useMemo } from "react";

const useLogsTableColumns = (): {
  logsTableColumns: Array<ColumnType>;
} => {
  const logsTableColumns = useMemo((): Array<ColumnType> => {
    const columns: Array<ColumnType> = [
      {
        prop: "comment_type",
        header: "Type",
        align: "center",
      },
      {
        prop: "comments",
        header: "Comment",
        align: "center",
      },
      {
        prop: "entered_user_id",
        header: "Entered By",
        align: "center",
      },
    ];

    return columns;
  }, []);

  return { logsTableColumns };
};

type LogsTableProps = {
  stopNotes: Array<StopNotes>;
};

export const StopNotesTable = ({
  stopNotes,
}: LogsTableProps): React.ReactElement => {
  const { logsTableColumns } = useLogsTableColumns();

  return (
    <section className="grid gap-[15px]">
      <h2 className="mb-2 text-center text-lg font-semibold text-gray-800">
        {`Stop Notes`}
      </h2>
      <Table
        columns={logsTableColumns}
        message="No Comments available"
        data={stopNotes ?? []}
        isLoading={false}
        getNextPage={() => false}
        hasMorePages={false}
        maxHeight={230}
        rowStyles={{
          borderBottom: 1,
          borderBottomStyle: "solid",
          borderBottomColor: "#F0F0F0",
        }}
      />
    </section>
  );
};
